<template>
  <div class="conteudoTable">
        <p  class="txtDadosG">Dados de Transporte</p>        
        <div class="dadosGerais">
             <div style="width:100%"> 
                <label for="">Modalidade do Frete</label><br>
                <input type="text" v-model="table.frete" readonly>
            </div>
        </div>
        <div v-if="table.transportador != null">
            <p  class="txtDadosG"  align="left">Transportador</p>
            <div class="dadosGerais" style="display:block;">
                <div style="display:flex ;justify-content: space-between;">
                    <div style="width:33%"> 
                        <label for="">CNPJ</label><br>
                        <input type="text" v-model="table.transportador.documento" readonly>
                    </div>
                    <div style="width:66.5%"> 
                        <label for="">Razão Social / Nome</label><br>
                        <input type="text" v-model="table.transportador.razaoSocial" readonly>
                    </div>
                </div>
                <div style="display:flex ;justify-content: space-between;">
                    <div style="width:33%;margin-top:7px;"> 
                        <label for="">Inscrição Estadual</label><br>
                        <input type="text" v-model="table.transportador.ie" readonly>
                    </div>
                    <div style="width:33%; margin-top:7px;"> 
                        <label for="">Endereço Completo</label><br>
                        <input type="text" v-model="table.transportador.endereco" readonly>
                    </div>
                    <div style="width:33%; margin-top:7px;"> 
                        <label for="">Munícipio</label><br>
                        <input type="text" v-model="table.transportador.municipio" readonly>
                    </div>
                </div>  
                <div style="display:flex ;justify-content: space-between;">
                    <div style="width:33%; margin-top:7px;"> 
                        <label for="">UF</label><br>
                        <input type="text" v-model="table.transportador.uf" readonly>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="table.volumes.length >0">
        <p  class="txtDadosG"  align="left">Volumes</p>
        <div class="dadosGerais" style="display:block;">
            <div v-for="(n,i) in table.volumes" :key="i">
                <p>Volume {{i+1}}</p>
                <div style="display:flex ;justify-content: space-between;">
                        <div style="width:33%;margin-top:7px;"> 
                            <label for="">Quantidade</label><br>
                            <input type="text" readonly v-model="n.quantidade">
                        </div>
                        <div style="width:33%; margin-top:7px;"> 
                            <label for="">Espécie</label><br>
                            <input type="text"  readonly v-model="n.especie">
                        </div>
                        <div style="width:33%; margin-top:7px;"> 
                            <label for="">Marca dos Volumes</label><br>
                            <input type="text" readonly v-model="n.marca">
                        </div>
                    </div>  
                    <div style="display:flex ;justify-content: space-between;">
                        <div style="width:33%;margin-top:7px;"> 
                            <label for="">Numeração</label><br> 
                            <input type="text"  readonly v-model="n.numeracao">
                        </div>
                        <div style="width:33%; margin-top:7px;"> 
                            <label for="">Peso Líquido</label><br>
                            <input type="text"  readonly v-model="n.pesoLiquido">
                        </div>
                        <div style="width:33%; margin-top:7px;"> 
                            <label for="">Peso Bruto</label><br>
                            <input type="text" readonly v-model="n.pesoBruto">
                        </div>
                    </div>  
            </div>
        </div>
        </div>
  </div>
</template>

<script>
export default {
    props:['table'],
    data(){
        return{
            
        }
    },
    

}
</script>

<style>

</style>